module.exports = __webpack_public_path__ + "static/SamaritanHealthServices2-061aff5451cff2558d8b8544989aea2a.png";